import type { HTMLAttributes } from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import type { ContentfulArticleSearchResponse } from 'autogen/swagger/all';
import Layout from 'components/Layout';
import ContainerFluid from 'components/Layout/components/ContainerFluid';
import HeaderSection from './components/HeaderSection';
import SectionNavigationRenderer from './components/SectionNavigation/SectionNavigationRenderer';
import ArticleUniverseGlobalStyling from './shared/ArticleUniverseGlobalStyling';

type ArticleUniverseLayoutProps = {
    sections: ContentfulArticleSearchResponse['sections'];
    frontPageUrl?: ContentfulArticleSearchResponse['frontPageUrl'];
    currentSectionId: ContentfulArticleSearchResponse['currentSectionId'];
    headline?: string;
    sectionName?: string;
} & HTMLAttributes<HTMLElement>;

function ArticleUniverseLayout({
    sections,
    headline,
    sectionName,
    frontPageUrl,
    currentSectionId,
    children
}: ArticleUniverseLayoutProps) {
    return (
        <>
            <ArticleUniverseGlobalStyling />
            <SectionNavigationRenderer
                sections={sections}
                frontPageUrl={frontPageUrl}
                currentSectionId={currentSectionId}
            />

            <Layout.Page>
                {headline && (
                    <ContainerFluid>
                        <HeaderSection headline={headline} sectionName={sectionName} />
                    </ContainerFluid>
                )}

                {children}
            </Layout.Page>
        </>
    );
}

export default withErrorBoundary(ArticleUniverseLayout, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
